import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function WorkerRating() {
    
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [assignmentList, setAssignmentList] = useState([]);
    const [workerList, setWorkerList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        assignment: "",
        worker: "",
        rating: "",
        review: ""
    });
    useEffect(() => {
        getRatings();
        getAssignments();
        getWorkers();
    }, []);
    const getRatings = () => {
        setLoading(true);
        axios.get(baseUrl + "workerrating/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getAssignments = () => {
        axios.get(baseUrl + "workassignment/")
            .then((res) => {
                setAssignmentList(res.data);
            });
    };
    const getWorkers = () => {
        axios.get(baseUrl + "workerprofile/")
            .then((res) => {
                setWorkerList(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            assignment: "",
            worker: "",
            rating: "",
            review: ""
        });
    };
    const saveData = (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("assignment", formData.assignment);
        data.append("worker", formData.worker);
        data.append("rating", formData.rating);
        data.append("review", formData.review);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        if (editId === null) {
            axios.post(baseUrl + "workerrating/", data)
                .then(() => {
                    Swal.fire("Success", "Worker Rating Saved", "success");
                    clearForm();
                    getRatings();
                });
        } else {
            axios.put(baseUrl + `update-workerrating/${editId}/`, data)
                .then(() => {
                    Swal.fire("Updated", "Worker Rating Updated", "success");
                    clearForm();
                    getRatings();
                });
        }
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            assignment: row.assignment,
            worker: row.worker,
            rating: row.rating,
            review: row.review
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete?",
            text: "Do you want to delete this record?",
            icon: "warning",
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`update-workerrating/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "", "success");
                        getRatings();
                    });
            }
        });
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70
        },
        {
            field: "assignment",
            headerName: "Assignment",
            width: 200,
            valueGetter: (params) => params.row.assignment?.id
        },
        {
            field: "worker",
            headerName: "Worker",
            width: 220,
            valueGetter: (params) =>
                params.row.worker ? `${params.row.worker.first_name} ${params.row.worker.last_name}` : ""
        },
        {
            field: "rating",
            headerName: "Rating",
            width: 100
        },
        {
            field: "review",
            headerName: "Review",
            width: 350
        },
        {
            field: "action",
            headerName: "Action",
            width: 180,
            renderCell: (params) => (
                <>

                    <button

                        className="btn btn-primary btn-sm me-2"

                        onClick={() => editData(params.row)}

                    >

                        Edit

                    </button>

                    <button

                        className="btn btn-danger btn-sm"

                        onClick={() => deleteData(params.row.id)}

                    >

                        Delete

                    </button>

                </>
            )
        }
    ];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">Worker Rating</h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">
                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Assignment
                                </label>

                                <select
                                    className="form-control"
                                    name="assignment"
                                    value={formData.assignment}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Assignment
                                    </option>

                                    {assignmentList.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.id}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Worker
                                </label>

                                <select
                                    className="form-control"
                                    name="worker"
                                    value={formData.worker}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Worker
                                    </option>

                                    {workerList.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.first_name} {item.last_name}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label className="form-label">
                                    Rating
                                </label>

                                <select
                                    className="form-control"
                                    name="rating"
                                    value={formData.rating}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Rating</option>
                                    <option value="1">1 - Poor</option>
                                    <option value="2">2 - Fair</option>
                                    <option value="3">3 - Good</option>
                                    <option value="4">4 - Very Good</option>
                                    <option value="5">5 - Excellent</option>
                                </select>

                            </div>

                            <div className="col-md-9 mb-3">

                                <label className="form-label">
                                    Review
                                </label>

                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="review"
                                    value={formData.review}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-12">

                                <button
                                    type="submit"
                                    className="btn btn-success me-2"
                                >
                                    {editId === null ? "Save" : "Update"}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={clearForm}
                                >
                                    Clear
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

            <div className="card shadow mt-3">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Worker Rating List
                    </h5>

                </div>

                <div className="card-body">

                    <div style={{height: 550, width: "100%"}}>

                        <ERPDataGrid
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            getRowId={(row) => row.id}
                            pageSizeOptions={[10, 25, 50, 100]}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}

                        />

                    </div>

                </div>

            </div>
        </div>
    );
}
export default WorkerRating;